import React from 'react';
import PropTypes from 'prop-types';
import { Carousel } from './Carousel';

function LogoCarousel({ ctaAction, logos }) {
  return (
    <div className="mt-logo-carousel">
      <h2>Connect to great applications like these</h2>
      <Carousel
        id="btLogoCarousel"
        infinite={false}
        slidesToShow={5}
        slidesToScroll={5}
        responsive={[
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ]}
      >
        {logos.map(([displayName, name]) => (
          <div
            className="mt-logo-carousel__item"
            key={`mt-logo-carousel-item-${name}`}
          >
            <div className="mt-logo-carousel__image-wrapper">
              <img
                alt={displayName}
                src={`../images/vm/m-track/logos/${name}-logo-large@1x.png`}
                srcSet={`../images/vm/m-track/logos/${name}-logo-large@1x.png 1x, ../images/vm/m-track/logos/${name}-logo-large@2x.png 2x`}
              />
            </div>
          </div>
        ))}
      </Carousel>
      <button
        onClick={ctaAction}
        className="mt-button mt-button--primary"
        aria-label="Get started (connect to great applications)"
      >
        Get started
      </button>
    </div>
  );
}

LogoCarousel.propTypes = {
  ctaAction: PropTypes.func,
  logos: PropTypes.arrayOf(
    PropTypes.arrayOf([PropTypes.string, PropTypes.string])
  ),
};

export { LogoCarousel };
